import propType from 'prop-types';
import React from 'react';
import Copyright from '../../components/Footer/Copyright';
import Information from '../../components/Footer/Information';
import HeaderNavigation from '../../components/HeaderNavigation';
import HelmetComponent from '../../components/Helmet';
import {
  Banner,
  BravoTabs,
  Introduction,
  Slogan,
  WhyChooseUs
} from './components';

export default function Home({ location }) {
  return (
    <>
      <HelmetComponent
        title="Human Resources Platform (HR Platform) - BravoSUITE"
        description="The Tool That Brings You The Ultimate Business Experience - BravoSUITE"
        image={{
          src: '/images/thumbnails/bravo-thumbnail.png',
          width: 720,
          height: 300
        }}
      />
      <HeaderNavigation type="normal" />
      <main id="home-page" className="home-page">
        <Slogan />
        <Introduction />
        <BravoTabs />
        <WhyChooseUs />
      </main>
      <footer className="home-page__footer">
        <Banner location={location} />
        <Information />
        <Copyright />
      </footer>
    </>
  );
}

Home.propTypes = {
  location: propType.shape({}).isRequired
};
